import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useAuthStore = create()(persist((set) => ({
    user: null,
    tenant: null,
    accessToken: null,
    refreshToken: null,
    isAuthenticated: false,
    setAuth: (user, tenant, accessToken, refreshToken) => set({ user, tenant, accessToken, refreshToken, isAuthenticated: true }),
    setToken: (accessToken) => set({ accessToken }),
    updateTenantBranding: (branding) => set((s) => ({
        tenant: s.tenant ? { ...s.tenant, branding } : null,
    })),
    logout: () => {
        const root = document.documentElement;
        ['--tenant-primary', '--tenant-secondary', '--tenant-accent', '--tenant-logo-url'].forEach(p => root.style.removeProperty(p));
        // Limpiado SINCRÓNICO de localStorage ANTES de setState para romper el ciclo 401/refresh
        localStorage.removeItem('gv-auth');
        set({ user: null, tenant: null, accessToken: null, refreshToken: null, isAuthenticated: false });
    },
}), {
    name: 'gv-auth',
    partialize: (s) => ({
        user: s.user,
        tenant: s.tenant,
        accessToken: s.accessToken,
        refreshToken: s.refreshToken,
        isAuthenticated: s.isAuthenticated,
    }),
}));
//# sourceMappingURL=auth.store.js.map